var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":`mailto: ${_vm.getEmailAddressSupport}`},domProps:{"textContent":_vm._s(_vm.getEmailAddressSupport)}})
}
var staticRenderFns = []

export { render, staticRenderFns }